import * as React from 'react';
import {Navigation} from "../../api";
import NavigationComponent from "./NavigationComponent";
import iconMenu from "../../assets/icons/menu.svg";
import SidebarArea from "./SidebarArea";
import {useSearchParams} from "react-router-dom";

interface INavigationArea {
    navigation: Navigation;
}

export const NavigationArea: React.FC<INavigationArea> = ({navigation}) => {

    const [searchParams] = useSearchParams();
    let searchParamsNavigation = searchParams.get("navigation");
    let initExpanded = false;

    if(searchParamsNavigation && searchParamsNavigation.length > 0) {
        initExpanded = true;
    }

    if (navigation && navigation.children) {
        return (
            <>
                <SidebarArea icon={iconMenu} title="Navigation" show={initExpanded}>
                    <ul className="navigation-list">
                        {
                            navigation.children.map((child) => {
                                return <NavigationComponent navigation={child}
                                                            key={child.label}/>;
                            })}
                    </ul>
                </SidebarArea>
            </>
        );
    }

    return <></>;

};

export default NavigationArea;
